const e=async e=>{await e.post(`/auth/logout`)};export{e as logout};
//# sourceMappingURL=logout.mjs.map